import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from 'react-accessible-accordion';
var unique = require('array-unique');

class TVChannels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      title: "Channel Compare",
      description: "Channel compare description here",
      channelList: [],
      toggleView: false
    };
  }
  componentWillMount() {


    const categoriesList = [Object.keys(this.props.categories).map(i => this.props.categories[i])];
    let categoriesListArr = [];

    for (var i = 0; i < categoriesList[0].length; i++) {
      categoriesListArr.push(categoriesList[0][i].category)
    };
    const channelsWithCategories = Object.keys(this.props.tvlogos).map(i => this.props.tvlogos[i]);


    //console.log("unique(categoriesListArr) >>", unique(categoriesListArr));

    /*************8 working *********/
    // console.log("channelsWithCategories >>>>", channelsWithCategories);

    let channels = channelsWithCategories;
    let CatList = channels.reduce((result, { category, image, title, alt, position, headingForExtra, extra }) => {
      result[category] = result[category] || [];
      result[category].push({ category, image, title, alt, position, headingForExtra, extra });
      return result;
    }, {});
    // let categoriesWithChannelList = Object.keys(CatList).map(category => ({ category, channels: CatList[category] }));
    let categoriesWithChannelList = Object.keys(CatList).map(category =>
      (
        {
          category, channels: CatList[category]
        }
      )
    );
    this.state.channelList = categoriesWithChannelList;
  }


  componentDidMount() {
    $(".accordion-chevron-down")[0].click();
    $(".extra-channel").each(function () {
      var childCnt = $(this).children();
      if (childCnt.length < 1) {
        $(this).css("display", "none");
      }
    });
  }

  imageSrcPath(fileName) {
    return fileName;
  }
  //toggleChevron ==> to toggle teh chevron on the RHS of the category name when expand / collapse
  toggleChevron = (e) => {
    (e.target.tagName.toUpperCase() === "SPAN") ? e.target.parentNode.classList.toggle("accordion-chevron-up") : e.target.classList.toggle("accordion-chevron-up");
  }

  //totalChannelsCount ==> to print the total number of channels available for each category
  totalChannelsCount = (channelsCnt, categoryName) => {
    setTimeout(() => {
      var totalCount = parseInt(channelsCnt);
      var channelCopy = (totalCount > 1) ? "Channels" : "Channel";
      $("#" + categoryName).find(".channels-count").text("(" + totalCount + "  " + channelCopy + ")");
    }, 500);
  }

  // replaces a particular character with space in a string
  //  Ex: when new category folder created with space in the openCMS, it adds a  hyphen and thisneeds to be replaced with a space and returns the string
  replaceCharWithSpace(paramone, replaceThis) {
    return paramone.replace(/-/g, ' ');

  }

  render() {
    let channelListItems = this.state.channelList;
    let getMainCategoriesList = this.props.sortCategories;
    //sort the main categories items based on sortIndex
    getMainCategoriesList = Object.keys(getMainCategoriesList).map(category =>
      (
        {
          category: getMainCategoriesList[category].categoryName, sortIndex:getMainCategoriesList[category].sortIndex
        }
      )
    );

    //add the sortIndex dynamically if sorting is not provided
    var getMaxSortIndexMainCat = Math.max.apply(Math, getMainCategoriesList.map(function(param) { return param.sortIndex; }))
    for(let a=0;a<getMainCategoriesList.length;a++) {
      if(getMainCategoriesList[a].sortIndex == "") {
        getMainCategoriesList[a].sortIndex = ++getMaxSortIndexMainCat;
      }
    }
    //sort the main category based on the sortIndex
    getMainCategoriesList.sort((a, b) => (parseInt(a.sortIndex) > parseInt(b.sortIndex)) ? 1 : -1);
    // let listForLogosSort = [];

    //sort the categorys based on the sortIndex provided in the CMS
    let sortedCategoryList = [];
    for(let k=0;k<getMainCategoriesList.length;k++) {
      for(let z=0;z<channelListItems.length;z++) {
        if(getMainCategoriesList[k].category === channelListItems[z].category) {
          sortedCategoryList.push(channelListItems[z]);
        }
      }
    }
channelListItems = sortedCategoryList;
    // sort the channels based on the navpos provided in the openCMS
    for (let cnt = 0; cnt < channelListItems.length; cnt++) {
      channelListItems[cnt].channels = channelListItems[cnt].channels.sort((a, b) => (parseInt(a.position) > parseInt(b.postition)) ? 1 : ((parseInt(b.position) > parseInt(a.position)) ? -1 : 0))
    }
    return (
      <Container className="channels-list-container">
        <Accordion allowZeroExpanded="true" allowMultipleExpanded="true" >
          {
            channelListItems.map((object, i) =>

              <AccordionItem key={object.category} id={object.category}>
                <AccordionItemHeading >
                  <AccordionItemButton >
                    <h3 className="accordion-chevron-down" onClick={this.toggleChevron.bind(this)} >{this.replaceCharWithSpace(object.category, '-')} <span className="channels-count" >{this.totalChannelsCount(object.channels.length, object.category)} </span></h3>
                  </AccordionItemButton>
                </AccordionItemHeading>

                <AccordionItemPanel>
                  {/* below is for showing the regular channels */}
                  <div className="channel-image-container">
                    {object.channels.map((object, i) =>

                      (object.image.indexOf(("extra")) < 0) ?
                        <img key={i} className="flex-small-12 flex-medium-6 flex-large-3 flex-colum" src={this.imageSrcPath(object.image)} alt={object.alt} title={object.title} />
                        :
                        ''
                    )}
                  </div>
                  {/* below is for showing the extra channels one liner heading - kept it separate div for align purpose across devices / resolutions*/}
                  <div className="extra-channel" >
                    {object.channels.map((object, ind) =>
                      (object.image.indexOf(("extra")) >= 0) ?
                        <p className="additional-text">{this.props.title}</p>
                        :
                        ''
                    )}
                  </div>
                  {/* below is for showing the extra channels */}
                  <div className="extra-channel channel-image-container " >
                    {object.channels.map((object, ind) =>
                      (object.image.indexOf(("extra")) >= 0) ?
                      (
                        <img key={"extra-image_" + ind} className="flex-small-12 flex-medium-6 flex-large-3 flex-colum" src={this.imageSrcPath(object.image)} alt={object.alt} title={object.title} />
                      )
                        :
                        ''
                    )}
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
            )
          }
        </Accordion>
      </Container>
    )
  }
}

export default TVChannels;